;
(function(){
  var sticky = document.getElementById('edSticky');
  if(sticky){
    var shown = false;
    function check(){
      var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if(scrollPct > 0.12 && !shown){ sticky.classList.add('ed-visible'); shown = true; }
    }
    window.addEventListener('scroll', check, {passive:true});
    check();
  }
  var faqBtns = document.querySelectorAll('.ed-faq-q');
  for(var i = 0; i < faqBtns.length; i++){
    faqBtns[i].addEventListener('click', function(){
      var answer = this.nextElementSibling;
      var arrow = this.querySelector('.ed-faq-arrow');
      if(answer.style.display === 'block'){
        answer.style.display = 'none';
        if(arrow) arrow.textContent = '+';
      } else {
        answer.style.display = 'block';
        if(arrow) arrow.textContent = '\u2212';
      }
    });
  }
})();
